import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faBars,
  faTimes,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";

function NavBar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div>
      <nav className="bg-primary p-12 flex items-center justify-between text-xl md:text-2xl lg:text-2xl custom:px-28">
        <div className="flex items-center space-x-4 md:space-x-6 lg:space-x-8">
          <a href="/">
            <img
              src="/images/logo.png"
              alt="Logo"
              className="h-8 md:h-12 lg:h-12"
            />
          </a>
        </div>

        {/* Desktop Menu */}
        <div className="hidden custom:flex custom:flex-grow items-center justify-center space-x-4 lg:space-x-8">
          <div className="relative">
            <button
              className="text-white flex items-center px-4 py-2 font-light"
              onClick={() => setAboutDropdownOpen(!aboutDropdownOpen)}
            >
              About Us
              <FontAwesomeIcon
                icon={aboutDropdownOpen ? faChevronUp : faChevronDown}
                className="ml-2"
              />
            </button>
            {aboutDropdownOpen && (
              <div className="absolute z-50 left-0 mt-2 bg-white text-black rounded-md shadow-lg p-4">
                <a
                  href="/about-sawa"
                  className="block px-4 py-2 hover:bg-gray-200"
                >
                  S.A.W.A
                </a>
                <a
                  href="/about-artists"
                  className="block px-4 py-2 hover:bg-gray-200"
                >
                  Artists
                </a>
              </div>
            )}
          </div>
          <a href="/conservation" className="text-white px-4 py-2 font-light">
            Conservation
          </a>
          <div
            className="relative"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <a
              href="/services"
              className="text-white flex items-center px-4 py-2 font-light"
            >
              Services
              <FontAwesomeIcon
                icon={dropdownOpen ? faChevronUp : faChevronDown}
                className="ml-2"
              />
            </a>
            {dropdownOpen && (
              <div className="absolute z-50 left-0 mt-2 bg-white text-black rounded-md shadow-lg p-4 w-84">
                <a
                  href="/services/art-studio-rental"
                  className="block px-4 py-2 text-md hover:bg-gray-200 whitespace-nowrap"
                >
                  Art Studio Rental
                </a>
                <a
                  href="/services/workshops-and-classes"
                  className="block px-4 py-2 text-md hover:bg-gray-200 whitespace-nowrap"
                >
                  Workshops and Classes
                </a>
                <a
                  href="/services/framing-and-restoration"
                  className="block px-4 py-2 text-md hover:bg-gray-200 whitespace-nowrap"
                >
                  Framing and Restoration
                </a>
                <a
                  href="/commissions"
                  className="block px-4 py-2 text-md hover:bg-gray-200 whitespace-nowrap"
                >
                  Commissions
                </a>
              </div>
            )}
          </div>
        </div>

        {/* Desktop Buttons */}
        <div className="hidden custom:flex items-center space-x-4 lg:space-x-8">
          <a href="/shop" className="bg-white text-primary font-bold px-4 py-2">
            Shop
          </a>
          <a
            href="/commissions"
            className="border border-white text-white font-bold px-4 py-2"
          >
            Commissions
          </a>
          <a href="/cart" className="text-white px-4 py-2">
            <FontAwesomeIcon icon={faShoppingCart} />
          </a>
        </div>

        {/* Mobile Menu Toggle Button */}
        <button
          className="custom:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="custom:hidden bg-primary text-white p-4">
          <div className="flex flex-col space-y-4">
            <div className="relative">
              <button
                onClick={() => setAboutDropdownOpen(!aboutDropdownOpen)}
                className="text-white flex items-center px-4 py-2"
              >
                About Us
                <FontAwesomeIcon
                  icon={aboutDropdownOpen ? faChevronUp : faChevronDown}
                  className="ml-2"
                />
              </button>
              {aboutDropdownOpen && (
                <div className="mt-2 bg-white text-black shadow-lg p-4">
                  <a
                    href="/about-sawa"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    S.A.W.A
                  </a>
                  <a
                    href="/about-artists"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    Artists
                  </a>
                </div>
              )}
            </div>
            <a href="/conservation" className="px-4 py-2">
              Conservation
            </a>
            <div
              className="relative"
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <a
                href="/services"
                className="text-white flex items-center px-4 py-2"
              >
                Services
                <FontAwesomeIcon
                  icon={dropdownOpen ? faChevronUp : faChevronDown}
                  className="ml-2"
                />
              </a>
              {dropdownOpen && (
                <div className="mt-2 bg-white text-black shadow-lg p-4">
                  <a
                    href="/services/art-studio-rental"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    Art Studio Rental
                  </a>
                  <a
                    href="/services/workshops-and-classes"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    Workshops and Classes
                  </a>
                  <a
                    href="/services/framing-and-restoration"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    Framing and Restoration
                  </a>
                  <a
                    href="/services/commissions"
                    className="block px-4 py-2 hover:bg-gray-200"
                  >
                    Commissions
                  </a>
                </div>
              )}
            </div>
            <a
              href="/shop"
              className="bg-white text-primary font-bold px-4 py-2"
            >
              Shop
            </a>
            <a
              href="/commissions"
              className="border border-white text-white font-bold px-4 py-2"
            >
              Commissions
            </a>
            <a href="/cart" className="text-white flex items-center px-4 py-2">
              <FontAwesomeIcon icon={faShoppingCart} />
              <span className="ml-2">Cart</span>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default NavBar;
